import React, {Fragment} from "react";
import {Col, FormGroup, ModalBody, ModalFooter, Row} from "reactstrap";
import {FiMinus, FiPlus} from "react-icons/fi";
import ZeusButton from "../../../components/Button";
import CustomFieldsList from "../../../components/Forms/CustomFieldsList";
import InputCreator from "../../../components/Forms/components/InputCreator";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import ToggleCreator from "../../../components/Forms/components/ToggleCreator";
import {useFetchWebhooks} from "../webhooksTable/useWebhooksTableData";
import {HTTP_METHODS} from "./constants";
import {useFormData} from "./useFormData";
import "./webhookForm.scss";

const WebHookForm = (props) => {
  const {data, onCancel} = props;
  const {refetch} = useFetchWebhooks();
  const callback = () => {
    onCancel();
    refetch();
  };
  const {
    formData,
    handleChange,
    handleHeaderChange,
    addHeaderField,
    removeHeaderField,
    handleSubmit,
  } = useFormData(data, callback);
  const {
    http_method,
    name,
    secret,
    ssl_verification,
    url,
    additional_headers = [],
    custom_fields = [],
  } = formData;

  return (
    <Fragment>
      <ModalBody>
        <Row>
          <InputCreator
            data-cy="name"
            isRequired
            inSingleRow
            label="Name"
            large
            name="name"
            onChange={handleChange}
            value={name}
          />
          <InputCreator
            data-cy="url"
            isRequired
            inSingleRow
            label="URL"
            large
            name="url"
            onChange={handleChange}
            value={url}
          />
          <SelectCreator
            classNamePrefix={"http-method"}
            id={"http-method"}
            isRequired
            inSingleRow
            label="HTTP Method"
            large
            name="http_method"
            onChange={handleChange}
            options={HTTP_METHODS}
            value={http_method}
          />
          <AdditionalHeaders
            additional_headers={additional_headers}
            addHeaderField={addHeaderField}
            handleHeaderChange={handleHeaderChange}
            removeHeaderField={removeHeaderField}
          />
          <InputCreator
            data-cy="secret"
            inSingleRow
            label="Secret"
            large
            name="secret"
            onChange={handleChange}
            value={secret}
          />
          <ToggleCreator
            data-cy="ssl-verification"
            inSingleRow
            checked={ssl_verification}
            label="SSL Verification"
            large
            onChange={() =>
              handleChange({target: {name: "ssl_verification", value: !ssl_verification}})
            }
          />
        </Row>
        <CustomFieldsList
          fields={custom_fields}
          onChange={(fields) => {
            handleChange({target: {name: "custom_fields", value: fields}});
          }}
        />
      </ModalBody>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
          SAVE
        </ZeusButton>
        <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
          CANCEL
        </ZeusButton>
      </ModalFooter>
    </Fragment>
  );
};

export default WebHookForm;

const AdditionalHeaders = (props) => {
  const {additional_headers, addHeaderField, handleHeaderChange, removeHeaderField} =
    props;
  return (
    <Col xs="12">
      <FormGroup row>
        <Col md="3">
          <label className="form-control-label roboto-bold" htmlFor="additional-headers">
            Additional Headers
          </label>
        </Col>
        <Col md="9">
          <div className="d-flex flex-column mb-2">
            {additional_headers.map((header, index) => (
              <Row key={index}>
                <InputCreator
                  colSize={4}
                  data-cy={"header-key"}
                  placeholder="Key"
                  name={`header-key-${index}`}
                  value={header.key}
                  onChange={(e) => handleHeaderChange(index, "key", e.target.value)}
                />
                <InputCreator
                  colSize={6}
                  data-cy={"header-value"}
                  placeholder="Value"
                  name={`header-value-${index}`}
                  value={header.value}
                  onChange={(e) => handleHeaderChange(index, "value", e.target.value)}
                />
                <Col md={1}>
                  <ZeusButton
                    classes="d-flex align-items-center justify-content-center"
                    data-cy={"remove-header-btn"}
                    type="secondary"
                    onClick={() => removeHeaderField(index)}
                    title="Remove header"
                    style={{
                      width: 36,
                      height: 42,
                      padding: 8,
                      minWidth: 36,
                    }}
                  >
                    <FiMinus size={16} />
                  </ZeusButton>
                </Col>
              </Row>
            ))}
            <div className="d-flex justify-content-end mr--2">
              <ZeusButton
                classes="d-flex align-items-center justify-content-center font-weight-normal"
                data-cy="add-header-btn"
                type="secondary"
                onClick={addHeaderField}
              >
                <FiPlus size={16} />
                <span>Add Header</span>
              </ZeusButton>
            </div>
          </div>
        </Col>
      </FormGroup>
    </Col>
  );
};
